import createIcon from '../../createIcon';

/**
 * @component @name TextRotationAngledown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMzk5NiA0LjQ4NDhMMTkuMzM5NiAzLjQyNDhMOC4xOTk2MSA3Ljg0NDgxTDkuNjc5NjEgOS4zMjQ4TDExLjg2OTYgOC40MDQ4TDE1LjQwOTYgMTEuOTQ0OEwxNC40ODk2IDE0LjEzNDhMMTUuOTY5NiAxNS42MTQ4TDIwLjM5OTYgNC40ODQ4Wk0xMy41ODk2IDcuNTg0ODFMMTguNDU5NiA1LjM1NDhMMTYuMjI5NiAxMC4yMjQ4TDEzLjU4OTYgNy41ODQ4MVpNMTUuMjY5NiAyMC41NzQ4VjE2LjMzNDhMMTMuODU5NiAxNy43NDQ4TDUuMDE5NjEgOC45MDQ4TDMuNTk5NjEgMTAuMzI0OEwxMi40Mzk2IDE5LjE2NDhMMTEuMDI5NiAyMC41NzQ4SDE1LjI2OTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TextRotationAngledown = createIcon('TextRotationAngledown', [
  [
    'path',
    {
      d: 'M20.3996 4.4848L19.3396 3.4248L8.19961 7.84481L9.67961 9.3248L11.8696 8.4048L15.4096 11.9448L14.4896 14.1348L15.9696 15.6148L20.3996 4.4848ZM13.5896 7.58481L18.4596 5.3548L16.2296 10.2248L13.5896 7.58481ZM15.2696 20.5748V16.3348L13.8596 17.7448L5.01961 8.9048L3.59961 10.3248L12.4396 19.1648L11.0296 20.5748H15.2696Z',
      key: '126hy2',
    },
  ],
]);

export default TextRotationAngledown;
